import React from "react";
import {Box} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

const Loading = () => (
    <div className="spinner" style={{textAlign: "center"}}>
      <Box sx={{ display: 'flex' }}>
        <CircularProgress />
      </Box>
    </div>
);

export default Loading;